import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { CultivosService } from "../../../../services/cultivos.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-cultivo-finca-new-edit',
    templateUrl: './new-edit.component.html'
})
export class CFNewEditComponent implements OnInit, OnDestroy {
    private _cultivoFinca;
    private readonly destroy$ = new Subject<void>();
    public newEditForm;
    public showError: boolean;
    public mensajes = new Array<Message>();
    public disable = false;
    public campanyas;
    public toCloseSpinner = 0;
    public denominacionesList;
    public productoresList;
    public denominacionId;
    public errorMsg;
    public duplicarCultivo = false;
    public cultivosDuplicar;
    public cultivo;
    public etiquetadores;

    public columns = ['Código GSV', 'Campaña', 'Denominación'];

    public properties = ['codigoGsv', 'anyo', 'desDenominacion'];

    public disabled: Subject<boolean> = new Subject();
    public disabledCultivos: Subject<boolean> = new Subject();
    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledProductores: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();

    @Input() cultivoFincaId;
    @Input() fincaId;
    @Input() desFinca;
    @Input() paisId;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            duplicarCultivos: [''],
            finca: [{value: this.desFinca, disabled: true}, Validators.required],
            denominacion: [{value: ''}, Validators.required],
            campanya: [{value: '', disabled: true }, Validators.required],
            cultivosDuplicar: [''],
            denominacionDuplicar: [''],
            campanyaDuplicar: [{value: '', disabled: true }],
            superficie: ['', Validators.required],
            nPlantas: ['', Validators.required],
            aforo: ['', Validators.required],
            alturaNivelMar: [''],
            etiquetador: [{value: '', disabled: true }]
        });

        this.getDenominaciones();

        if (this.cultivoFincaId) {
            this.getCultivoFinca();
        } else {
            this.getCultivosADuplicar();
        }

        this.newEditForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                let filters = {
                    denominacionId: denominacion.id,
                    habilitada: true,
                    volcadoHistorico: false,
                    paisId: this.paisId
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getCampanyasByDenominacionId(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.campanyas = resp.lista;
                        this.campanyas.forEach(campanya => {
                            campanya.des = campanya.anyo.toString();
                        });
                        if (this.campanyas.filter( x => x.habilitada).length === 1) {
                        this.newEditForm.patchValue({
                            campanya: this.campanyas.find(x => x.habilitada),
                        });
                        }
                        this.newEditForm.get('campanya').setValidators(Validators.required);
                        this.newEditForm.get('campanya').enable();
                        this.newEditForm.get('campanya').updateValueAndValidity();
                    }
                    else {
                        this.newEditForm.get('campanya').setValidators(Validators.required);
                        this.newEditForm.get('campanya').enable();
                        this.newEditForm.get('campanya').updateValueAndValidity();
                        this.disabled.next(false);
                    }
                });
                this.getEtiquetadoresByDenominacionId(denominacion.id);
            } else {
                this.campanyas = null;
                this.disabled.next(true);
                this.newEditForm.get('campanya').reset();
                this.etiquetadores = null;
                this.disabledEtiquetadores.next(true);
                this.newEditForm.get('etiquetador').reset();
            }
        });

        this.newEditForm.get('duplicarCultivos').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            if (value) {
              this.duplicarCultivo = true;
              this.newEditForm.get('cultivosDuplicar').setValidators(Validators.required);
              this.newEditForm.get('cultivosDuplicar').enable();
              this.newEditForm.get('cultivosDuplicar').updateValueAndValidity();
              this.disabledCultivos.next(false);
              this.newEditForm.get('denominacionDuplicar').setValidators(Validators.required);
              this.newEditForm.get('denominacion').clearValidators();
            } else {
              this.duplicarCultivo = false;
              this.newEditForm.get('cultivosDuplicar').reset();
              this.newEditForm.get('denominacionDuplicar').reset();
              this.newEditForm.get('denominacionDuplicar').clearValidators();
              this.newEditForm.get('denominacion').setValidators(Validators.required);
              this.newEditForm.get('superficie').reset();
              this.newEditForm.get('nPlantas').reset();
              this.newEditForm.get('aforo').reset();
              this.newEditForm.get('alturaNivelMar').reset();
              this.newEditForm.get('cultivosDuplicar').disable();
              this.newEditForm.get('cultivosDuplicar').updateValueAndValidity();
              this.disabledCultivos.next(true);
            }
        });

        this.newEditForm.get('cultivosDuplicar').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((cultivo) => {
            if (cultivo) {
                this.newEditForm.patchValue({
                    denominacionDuplicar: this.denominacionesList.find(x => x.id === cultivo.denominacionId),
                    superficie: cultivo.superficie,
                    nPlantas: cultivo.nPlantas,
                    aforo: cultivo.aforo,
                    alturaNivelMar: cultivo.alturaNivelMar
                });
                this.cultivo = cultivo;
            } else {
                this.campanyas = null;
                this.disabled.next(true);
                this.newEditForm.get('denominacionDuplicar').reset();
                this.newEditForm.get('superficie').reset();
                this.newEditForm.get('nPlantas').reset();
                this.newEditForm.get('aforo').reset();
                this.newEditForm.get('alturaNivelMar').reset();
            }
        });

        this.newEditForm.get('denominacionDuplicar').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                let filters = {
                    denominacionId: denominacion.id,
                    habilitada: true,
                    volcadoHistorico: false,
                    paisId: this.paisId
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getCampanyasByDenominacionId(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.campanyas = resp.lista;
                        this.campanyas.forEach(campanya => {
                            campanya.des = campanya.anyo.toString();
                        });
                        if (this.campanyas.filter( x => x.habilitada).length === 1) {
                        this.newEditForm.patchValue({
                            campanyaDuplicar: this.campanyas.find(x => x.habilitada).des,
                        });
                        }
                    }
                    else {
                    }
                });
            } else {
                this.campanyas = null;
                this.disabled.next(true);
                this.newEditForm.get('campanya').reset();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public getEtiquetadoresByDenominacionId(denominacionId){
      let filters = {
        denominacionId: denominacionId,
        paisId: this.paisId
      };
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._cultivosService.getEtiquetadoresByDenominacionId(filters).toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          if (resp.lista.length > 0) {
            this.etiquetadores = resp.lista;
            this.newEditForm.get('etiquetador').enable();
            this.disabledEtiquetadores.next(false);
          } else {
            this.newEditForm.get('etiquetador').disable();
            this.disabledEtiquetadores.next(true);
          }
      });
    }

    public getDenominaciones() {
        let filters = {
            paisId: this.paisId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getDenominacionesByPaisId(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.denominacionesList = resp.lista;
            if (this.denominacionesList.length === 1) {
                this.newEditForm.get('denominacion').patchValue(this.denominacionesList[0]);
                this.newEditForm.get('denominacion').disable();
                this.disabledDenominaciones.next(true);
            }
        });
    }

    public getCultivosADuplicar() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getCultivosByFincasADuplicar(this.fincaId).toPromise().finally(() => {
            this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.length > 0) {
                    this.cultivosDuplicar = resp;
                    this.cultivosDuplicar.forEach(element => {
                        element.des = this.desFinca;
                    });
                } else {
                    this.newEditForm.get('duplicarCultivos').disable();
                }
            });
    }

    public getCultivoFinca() {
        this._spinnerService.showSpinner();
        this._cultivosService.getCultivoFinca(this.cultivoFincaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._cultivoFinca = resp;
            this.newEditForm.patchValue({
                superficie: resp.superficie,
                nPlantas: resp.nPlantas,
                aforo: resp.aforo,
                alturaNivelMar: resp.alturaNivelMar
            });
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.cultivoFincaId) {
            this._cultivoFinca = {
                campanyaId: this.duplicarCultivo ? this.campanyas.find(x => x.habilitada).id : this.newEditForm.get('campanya').value.id,
                fincaId: this.fincaId,
                codigoGsv: this.duplicarCultivo ? this.cultivo.codigoGsv : null,
                parentId: this.duplicarCultivo && (this.cultivo.denominacionId === this.newEditForm.get('denominacionDuplicar').value.id) ?
                          this.cultivo.id : null,
                superficie: this.newEditForm.get('superficie').value,
                nPlantas: this.newEditForm.get('nPlantas').value,
                aforo: this.newEditForm.get('aforo').value,
                alturaNivelMar: this.newEditForm.get('alturaNivelMar').value,
                parcelas: this.duplicarCultivo ? this.cultivo.lsCatastros : null,
                cultivosProductor: this.duplicarCultivo ? this.cultivo.productoresDuplicados : null,
                etiquetadorId: this.newEditForm.get('etiquetador').value ? this.newEditForm.get('etiquetador').value.id : null
            };
            this._spinnerService.showSpinner();
            this._cultivosService.createCultivoFinca(this._cultivoFinca).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            },
            (error) => {
                if (error.status === 420) {
                    switch (error.error.ApiErrorCode){
                        case 6048:
                            this.errorMsg = this._translate.instant('ApiErrors.cultivoMismaDeno');
                            break;
                        case 6073: //fechaDesignacionNoIncluidaEnCampanya
                          this.errorMsg = this._translate.instant('ApiErrors.fechaDesignacionNoIncluidaEnCampanya');
                          break;
                        default:
                            this.errorMsg = this._translate.instant('ApiErrors.errorCultivo');
                            break;
                    }
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: this.errorMsg });
                }
                else {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                 }
            });
        } else if (this.newEditForm.valid && this.cultivoFincaId) {
            this._cultivoFinca = {
                id: this.cultivoFincaId,
                campanyaId: this._cultivoFinca.campanyaId,
                fincaId: this.fincaId,
                superficie: this.newEditForm.get('superficie').value,
                nPlantas: this.newEditForm.get('nPlantas').value,
                aforo: this.newEditForm.get('aforo').value,
                alturaNivelMar: this.newEditForm.get('alturaNivelMar').value,
            };
            this._spinnerService.showSpinner();
            this._cultivosService.updateCultivoFinca(this._cultivoFinca).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode){
                            case 6048:
                                this.errorMsg = this._translate.instant('ApiErrors.cultivoMismaDeno');
                                break;
                            default:
                                this.errorMsg = this._translate.instant('ApiErrors.errorCultivo');
                                break;
                        }
                        this.showError = true;
                        this.mensajes.push({ class: 'error', message: this.errorMsg });
                    }
                    else {
                        this.showError = true;
                        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                     }
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
          this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }

    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
        }
    }
}
